// extracted by mini-css-extract-plugin
module.exports = {"root":"Features-module--root--6UC5o","wrapper":"Features-module--wrapper--1ITaB","image":"Features-module--image--1S3AH","content":"Features-module--content--3jAtU"};